export default "__VITE_ASSET__BZc7JZFn__"